import { ReactElement, useState } from 'react';

import { Button, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';

import { Payout, PayoutDetailsModal } from './Components/PayoutModals';
import { TableRowLoader } from '../../components/TableRowLoader';
import { getAmountView, getLocalTimezoneCode, utcDateTimeToLocal } from '../../utils/format';

type PayoutsTableProps = {
  customerAppId: string;
  items: Payout[];
  isLoading: boolean;
};

export const PayoutsTable = ({ customerAppId, items, isLoading }: PayoutsTableProps): ReactElement => {
  const [itemIndex, setItemIndex] = useState<number>(-1);
  const [showDetails, setShowDetails] = useState<boolean>(false);

  const localTimezoneCode = getLocalTimezoneCode();

  const handleClose = () => {
    setItemIndex(-1);
    setShowDetails(false);
  };

  return (
    <TableContainer component={Paper}>
      <Table aria-label="payouts table">
        <TableHead>
          <TableRow sx={{ '& th': { fontWeight: 600 } }}>
            <TableCell align="center">Updated At ({localTimezoneCode})</TableCell>
            <TableCell align="center">Payout ID</TableCell>
            <TableCell align="center">Status</TableCell>
            <TableCell align="center">Type</TableCell>
            <TableCell align="center">Amount</TableCell>
            <TableCell align="center">Currency</TableCell>
            <TableCell align="center">Recipient</TableCell>
            <TableCell align="center">Details</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <PayoutDetailsModal
            open={itemIndex !== -1 && showDetails}
            handleClose={handleClose}
            details={items[itemIndex]}
            customerAppId={customerAppId}
          />
          {isLoading ? (
            <TableRowLoader rows={10} columns={8} />
          ) : (
            items.map((item, index) => (
              <TableRow key={item.payout_id} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                <TableCell align="center">{item.updated_at ? utcDateTimeToLocal(item.updated_at) : ''}</TableCell>
                <TableCell align="center">{item.payout_id}</TableCell>
                <TableCell align="center">{item.status}</TableCell>
                <TableCell align="center">{item.type}</TableCell>
                <TableCell align="center">{getAmountView(item.currency, item.amount)}</TableCell>
                <TableCell align="center">{item.currency}</TableCell>
                <TableCell align="center">{item.recipient?.name}</TableCell>
                <TableCell align="center">
                  <Button
                    onClick={() => {
                      setItemIndex(index);
                      setShowDetails(true);
                    }}
                  >
                    {item.payment_details?.description}
                  </Button>
                </TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
